import React, {Component} from 'react';

import { Modal, Button } from 'react-bootstrap';

import styled from 'styled-components';

import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';

import Header from '../../Layouts/Header';
import Flash from '../../Shared/Flash';
import Utils from '../../../lib/utils';
import {
  addFlashMessage as addFlashMessageAction
} from '../../../redux/middleware/flashMessage';
import {
  getProfile as getProfileAction,
  applyProfiles as applyProfilesAction
} from '../../../redux/middleware/profile';
import {
  getProfilesError, getProfile, getProfilesPending,
  applyProfilesPending, applyProfilesSuccess, applyProfilesError
} from '../../../redux/reducers/profile';

import Sidebar from './Sidebar';
import {DocumentViewer} from '../../Shared'
const styles = {
  title: {
    margin: '15px 0 20px',
    fontWeight: 700,
    color: '#39b54a',
    fontSize: 24,
    borderBottom: '1px solid #8da3aa',
    paddingBottom: 15
  },
  icon: {
    color: '#39b54a'
  },
  iconsList: {
    padding: 0
  },
  icons: {
    paddingRight: 10
  },
  description: {
    fontSize: 14,
    color: '#8290a2',
    lineHeight: 1.5
  },
  container: {
    paddingTop: 20,
  }
}

const ApplyNow = styled.button`
 margin-top: 20px;
 margin-bottom: 20px;
 position: absolute;
 @media screen and (max-width: 767px) {
   width: 100%;
   margin-bottom: 40px;
 }
`
const ProfilesDescription = styled.div`
  margin-bottom: 100px;
  @media screen and (max-width: 767px) {
    margin-bottom: 40px;
  }
`

const ProfileModal = ({handleChange, profiles, profileType, borderColor, show}) =>
  <div className={`static-modal ${ !show && 'hidden' }`}>
    <Modal.Dialog>
      <Modal.Header>
        <Modal.Title>Select your profile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <select id="singleSelect" name="profile_type" className="form-control form-control-lg" value={profileType} onChange={handleChange} style={{borderColor: borderColor}} >
          <option value='0'>Select your profile</option>
          {
          profiles && profiles.map((profile, index) => {
              return(
                <option value={profile.id} key={"option_" + index}>{profile.title}</option>
              )
            })
          }
        </select>
      </Modal.Body>
    </Modal.Dialog>
  </div>

class Profile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      profile_type: '0',
      open_model: false,
      borderColor: ''
    }
  }

  shouldComponentRender = () => {
    const {pending, job} = this.props;
    if (this.pending === false) return false;
    if (job === undefined) return false;
    return true;
  }

  componentWillMount = () => {
    this.props.getProfiles(this.props.slug);
    window.scrollTo(0, 0);
  }

  componentWillReceiveProps = (nextProps) => {
    const job = this.props.job;
    if (job && job.slug !== nextProps.slug) {
      this.props.getProfiles(nextProps.slug)
    }
    window.scrollTo(0, 0);
  }

  trim = (message, maxLength) => {
    if (message.length > maxLength) {
      let trimmedString = message && message.substr(0, maxLength); //trim the string to the maximum length
      // re-trim if we are in the middle of a word
      trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));
      trimmedString += '...'
      return trimmedString;
    }
    return message;
  }

  handleChange = (e) => {
    this.setState({
      profile_type: e.target.value
    })
  }

  handleApply = () => {
    this.setState({
      open_model: true,
      borderColor: ''
    })
  }

  // handleApplyProfiles = (type) => {
  //   const profileId = this.state.profile_type; // TODO: get real id
  //   const { user, job } = this.props;

  //   if( profileId !== '0' ) {
  //     this.setState({borderColor: ''})
  //     if( type === 'open' ) {
  //      // this.props.applyProfiles(user, profileId, job);
  //       this.setState({open_model: false});
  //       this.props.addFlashMessage('You successfully applied');
  //     }
  //   } else {
  //     this.setState({borderColor: '#a94442'})
  //   }

  //   if( type !== 'open' )this.setState({open_model: false})
  // }

  address = (job) => {
    if (!job.city)
      return job.state;
    else
      return job.city && job.city + ', ' + job.state;
  }

  render() {
    console.log("user",this.props.profiles)
    if(!this.shouldComponentRender()) return <div>Loading...</div>

    const { profile_type, borderColor } = this.state;
    let { user,profiles, history, error,job } = this.props;
    let title = job.title || "Welcome to QuirkyCoders";

    document.title = `${title} | Where Developers and Employers connect!`;

    return (

      <div className="container">
          <Flash />
          <Header user={this.props.user} history={history} job={profiles} trim={this.trim} address={this.address} handleApply={this.handleApply}/>
          <div className="row" style={styles.container}>
            <div className="col-md-9">
              <ProfilesDescription>
                <h1 style={styles.title}>Profile Info</h1>
                <div style={styles.description} dangerouslySetInnerHTML={{
                    __html: Utils.stripHtml(job.description)
                }}/>

                { Utils.isApplicant(user) && !Utils.hasApplied(user, job) &&
                  <ApplyNow
                    className="btn btn-primary btn_apply"
                    onClick={() => this.handleApply}>
                    Apply now
                  </ApplyNow> }

              </ProfilesDescription>
            </div>
            <div className="col-md-3">
              <Sidebar jobs={this.props.jobs} address={this.address}/>
            </div>
          </div>
        <ProfileModal
          handleChange={this.handleChange}
          profiles={profiles}
          show={this.state.open_model}
          profileType={profile_type}
          borderColor={borderColor}
          handleApplyProfiles={null}
        />

      </div>
    )
  }
}

const mapStateToProps = state => ({
    error: getProfilesError(state),
    profile: getProfile(state),
    pending: getProfilesPending(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({
    getProfile: getProfileAction,
    // applyProfiles: applyProfilesAction,
    addFlashMessage: addFlashMessageAction
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Profile)
